module.exports = __webpack_public_path__ + "admean.png";


//////////////////
// WEBPACK FOOTER
// ./web_modules/trustar/icons/admean.png
// module id = 3478
// module chunks = 39